import { MarqCommonEnumsAiClientTagEnum } from '~/swagger/data-contracts';

export const TAG_FILTER_LABEL: Record<MarqCommonEnumsAiClientTagEnum, string> = {
  [MarqCommonEnumsAiClientTagEnum.Trademark]: 'Trademarked logo used',
  [MarqCommonEnumsAiClientTagEnum.TextDetection]: 'Trademarked text used',
  [MarqCommonEnumsAiClientTagEnum.ClientRequested]: 'Requested by me',
  [MarqCommonEnumsAiClientTagEnum.InfringingImage]: 'Infringing image used',
  [MarqCommonEnumsAiClientTagEnum.OfficialImage]: 'Copyrighted image used',
  [MarqCommonEnumsAiClientTagEnum.RepeatOffender]: 'Repeat offender',
  [MarqCommonEnumsAiClientTagEnum.LowPrice]: 'Low price',
  [MarqCommonEnumsAiClientTagEnum.TopResult]: 'Top search results',
};
